import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NavPreferencesState {
  /** False collapses the sidebar to an icon rail. */
  showLabels: boolean;
  setShowLabels: (showLabels: boolean) => void;
  toggleLabels: () => void;
}

/**
 * Whether the sidebar is expanded.
 *
 * Persisted because it is a workspace preference rather than view state — a
 * user who collapses the sidebar expects it collapsed tomorrow. This is exactly
 * the kind of thing zustand owns; anything from the server belongs in TanStack
 * Query instead.
 */
export const useNavPreferences = create<NavPreferencesState>()(
  persist(
    (set) => ({
      showLabels: true,
      setShowLabels: (showLabels) => set({ showLabels }),
      toggleLabels: () => set((state) => ({ showLabels: !state.showLabels })),
    }),
    {
      name: 'opengoal.nav',
      // Earlier versions also stored a `placement` (sidebar vs top bar). Only
      // the sidebar remains, so anything else in the stored object is dropped.
      partialize: (state) => ({ showLabels: state.showLabels }),
    },
  ),
);
